import { render, staticRenderFns } from "./hcmIndexChild.vue?vue&type=template&id=c5b0cbba"
import script from "./hcmIndexChild.vue?vue&type=script&lang=js"
export * from "./hcmIndexChild.vue?vue&type=script&lang=js"
import style0 from "./hcmIndexChild.vue?vue&type=style&index=0&id=c5b0cbba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports